/**
 * 获取控制中心设置的组件动态属性
 * @param {
 *   marketModuleId: this.moduleObject.comId,
 *   pageId: IDM.broadcast ? IDM.broadcast.pageModule.id : "",
 *   packageid: this.moduleObject.packageid
 * } paramObject 
 * @param {function(){}} success 
 * @param {function(){}} error 
 */
function getModuleAttrList(paramObject, success, error) {
    IDM.http
        .get(IDM.setting.api.dynamicAttributeListUrl, {
            urlData: JSON.stringify(paramObject),
        })
        .then((res) => {
            success && success(res)
        })
        .catch((err) => {
            error && error(err);
        });
}
/**
 * 获取控制中心设置的组件动态http实例
 * @param {
 *   marketModuleId: this.moduleObject.comId,
 *   pageId: IDM.broadcast ? IDM.broadcast.pageModule.id : "",
 *   packageid: this.moduleObject.packageid
 * } paramObject 
 * @returns http axios
 */
function getModuleAttrInstance(paramObject) {
    return IDM.http
        .get(IDM.setting.api.dynamicAttributeListUrl, {
            urlData: JSON.stringify(paramObject),
        });
}
/**
 * 获取控制中心获取组件属性的接口地址
 * @returns 
 */
function getModuleAttrInterfaceUrl(){
    return IDM.setting.api.dynamicAttributeListUrl
}

export default {
    getModuleAttrList,
    getModuleAttrInstance,
    getModuleAttrInterfaceUrl
}